import React from 'react';
import logo from "../../assets/img/logo.svg";

function TimesheetItem({ timesheet, isSelected, onClick }) {
    return (
        <div
            className={`timesheet-item ${isSelected ? 'selected' : ''} ${timesheet.status === 'À FAIRE' ? '' : 'archived'}`}
            onClick={onClick}
        >
            <div>
                <p >{timesheet.date}</p>
                <h3>{timesheet.name}</h3>
                <p>{timesheet.role}</p>
            </div>
            <div>
                <div className={`status ${timesheet.status === 'À FAIRE' ? 'todo' : 'archived'}`}>
                    {timesheet.status}
                </div>
                <img src={logo} alt="icon" />
            </div>
        </div>
    );
}

export default TimesheetItem;
